import { api } from "./client";

export type PersonRow = {
  id: number;
  email: string;
  name: string;
  department: string | null;
  last_event_at: string | null;
  conversation_count: number;
  last_conversation_at: string | null;
  adoption_status: "active" | "occasional" | "inactive" | "never";
};

export type ActivityRow = {
  event_timestamp: string;
  event_name: string;
  source: string;
  model: string | null;
  tool_name: string | null;
  cost_usd: number | null;
  duration_ms: number | null;
  error: string | null;
};

export const peopleApi = {
  list: (department?: string) =>
    api.get<PersonRow[]>(`/people${department ? `?department=${encodeURIComponent(department)}` : ""}`),
  activity: (userId: number) => api.get<ActivityRow[]>(`/people/${userId}/activity`),
};
